function trimTrailingSlash(value: string): string {
  return value.endsWith("/") ? value.slice(0, -1) : value
}

function trimLeadingSlash(value: string): string {
  return value.startsWith("/") ? value.slice(1) : value
}

export function resolveApiUrl(base: string, path: string): string {
  const normalizedBase = trimTrailingSlash(base)
  const normalizedPath = path.startsWith("/") ? path : `/${path}`

  if (normalizedBase.endsWith("/api") && normalizedPath.startsWith("/api/")) {
    return `${normalizedBase}/${trimLeadingSlash(normalizedPath.slice(4))}`
  }

  return `${normalizedBase}${normalizedPath}`
}
